import * as React from "react";
import {Item} from "components/models/Quotation";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import NumberFormat from "react-number-format";
import {Button} from "react-bootstrap";

interface Props {
  item: Item
}

export default class extends React.Component<Props> {

  items() {
    return this.props.item.components.map((i) =>
      <tr key={`${JSON.stringify(i.id)}`}>
        <td>{i.product.name}</td>
        <td>{i.quantity}</td>
        <td>{i.length}</td>
        <td>{i.width}</td>
        <td>{i.bulk_purchase ? "Yes" : "No"}</td>
        <td>{<NumberFormat value={(i.quantity * i.product_cost.cents) / 100} prefix={"£"} displayType={"text"}
                           thousandSeparator={true}
                           decimalScale={2} fixedDecimalScale={true}/>}</td>
        <td>{<NumberFormat value={(i.quantity * i.product_price.cents) / 100} prefix={"£"} displayType={"text"}
                           thousandSeparator={true}
                           decimalScale={2} fixedDecimalScale={true}/>}</td>
      </tr>
    )
  }

  addComponent() {
    alert("Add!");
  }

  render() {
    return <>
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between py-3">
          <div className="align-self-center">
            { this.props.item.name }
          </div>
          <div className="align-self-center">
            { <Button variant="primary" size="sm" onClick={() => this.addComponent()}>Add</Button> }
          </div>
        </Card.Header>
        <Table className="padded no-top-border">
          <thead>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Length</th>
            <th>Width</th>
            <th>Bulk</th>
          </tr>
          </thead>
          <tbody>{this.items()}
          </tbody>
        </Table>
      </Card>
    </>
  }
}